"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredPermissionsExists = void 0;
function requiredPermissionsExists(...args) {
    const requiredPermissions = args[0];
    const grantedPermissions = args[1];
    if (Array.isArray(requiredPermissions) && Array.isArray(grantedPermissions)) {
        return requiredPermissions.some((permission) => grantedPermissions.includes(permission));
    }
    else {
        const services = Object.keys(requiredPermissions);
        if (services.length === 0) {
            return true;
        }
        for (const service in services) {
            const serviceName = services[service];
            if (grantedPermissions[serviceName]) {
                return requiredPermissionsExists(requiredPermissions[serviceName], grantedPermissions[serviceName]);
            }
        }
        return false;
    }
}
exports.requiredPermissionsExists = requiredPermissionsExists;
//# sourceMappingURL=check-permissions.js.map